interface PaidIconProps {
  /** Rendered size in px. 18 is the tab size the design draws (docs/design/Настройки.dc.html). */
  size?: number
  className?: string
}

export const PaidIcon = ({ size = 18, className }: PaidIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.545 3.18572L6.46134 0.662975C6.39481 0.583053 6.31234 0.516775 6.2188 0.46805C6.12525 0.419326 6.02252 0.389143 5.91667 0.379281C5.70414 0.360827 5.49267 0.424162 5.32846 0.555446L2.09371 3.18572H8.545Z"
        fill="currentColor"
      />
      <path
        d="M6.70833 10.0493V9.28667C6.70833 8.47763 7.04196 7.70173 7.63583 7.12966C8.22969 6.55758 9.03515 6.23619 9.875 6.23619H13.8333V5.47357C13.8333 5.27131 13.7499 5.07734 13.6015 4.93432C13.453 4.7913 13.2516 4.71096 13.0417 4.71096H1.16667C0.956704 4.71096 0.75534 4.7913 0.606874 4.93432C0.458407 5.07734 0.375 5.27131 0.375 5.47357V13.8624C0.375 14.0646 0.458407 14.2586 0.606874 14.4016C0.75534 14.5447 0.956704 14.625 1.16667 14.625H13.0417C13.2516 14.625 13.453 14.5447 13.6015 14.4016C13.7499 14.2586 13.8333 14.0646 13.8333 13.8624V13.0998H9.875C9.03515 13.0998 8.22969 12.7784 7.63583 12.2063C7.04196 11.6342 6.70833 10.8583 6.70833 10.0493Z"
        fill="currentColor"
      />
      <path
        d="M13.8333 7.76143H9.875C9.45507 7.76143 9.05235 7.92213 8.75541 8.20816C8.45848 8.4942 8.29167 8.88215 8.29167 9.28667V10.0493C8.29167 10.4538 8.45848 10.8418 8.75541 11.1278C9.05235 11.4138 9.45507 11.5745 9.875 11.5745H13.8333C14.0433 11.5745 14.2447 11.4942 14.3931 11.3512C14.5416 11.2081 14.625 11.0142 14.625 10.8119V8.52405C14.625 8.32179 14.5416 8.12782 14.3931 7.9848C14.2447 7.84178 14.0433 7.76143 13.8333 7.76143ZM11.0625 10.4306C10.9059 10.4306 10.7529 10.3859 10.6227 10.3021C10.4925 10.2183 10.391 10.0992 10.3311 9.95982C10.2712 9.82047 10.2555 9.66713 10.286 9.5192C10.3166 9.37126 10.392 9.23538 10.5027 9.12873C10.6134 9.02207 10.7545 8.94944 10.9081 8.92001C11.0616 8.89059 11.2208 8.90569 11.3655 8.96341C11.5101 9.02113 11.6338 9.11888 11.7207 9.24429C11.8077 9.3697 11.8542 9.51715 11.8542 9.66798C11.8542 9.87024 11.7708 10.0642 11.6223 10.2072C11.4738 10.3502 11.2725 10.4306 11.0625 10.4306Z"
        fill="currentColor"
      />
      <path
        d="M9.68738 3.18572H11.7117L9.628 0.662974C9.49719 0.504605 9.30644 0.402779 9.09769 0.379896C8.88895 0.357013 8.67932 0.414948 8.51492 0.540955C8.35052 0.666963 8.24481 0.850721 8.22106 1.05181C8.1973 1.25289 8.25744 1.45483 8.38825 1.6132L9.68738 3.18572Z"
        fill="currentColor"
      />
    </svg>
  )
}
